module.exports = __webpack_public_path__ + "media/images/tooltip-ca6715e2.png";